module.exports = __webpack_public_path__ + "img/qrcode-gzh.e6df8667.png";